import TableContainer from "./table-container.vue";

export default TableContainer;



// WEBPACK FOOTER //
// ./src/components/_table-container/index.js